module.exports = __webpack_public_path__ + "static/media/index-bg02.2a9f8a86.jpg";